import TagManager from "react-gtm-module";

const GTM_ID = import.meta.env.VITE_GTM_ID || "GTM-KSTH25ZC";

export const initGTM = () => {
  if (typeof window === "undefined" || !GTM_ID) return;
  if ((window as any).gtmInitialized) return;

  TagManager.initialize({ gtmId: GTM_ID });
  (window as any).gtmInitialized = true;
};
